'use client'

import { useEffect } from 'react'
import { Sentry, initSentry } from '@/lib/sentry'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  initSentry()

  useEffect(() => {
    console.error('[Global Error Boundary] Critical error:', error)
    Sentry.captureException(error)
  }, [error])

  return (
    <html>
      <body style={{
        margin: 0,
        padding: 0,
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#0a0a0a',
        color: '#ffffff',
        fontFamily: 'system-ui, -apple-system, sans-serif',
      }}>
        <div style={{
          textAlign: 'center',
          padding: '2rem',
          maxWidth: '600px',
        }}>
          <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>
            Critical Error
          </h1>
          <p style={{ marginBottom: '2rem', opacity: 0.7, fontSize: '1.1rem' }}>
            A critical error occurred in the application. Please refresh the page or return to the homepage.
          </p>
          <p style={{ marginBottom: '2rem', fontSize: '0.9rem', opacity: 0.5 }}>
            {error.message}
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
            <button
              onClick={() => reset()}
              style={{
                padding: '0.875rem 2rem',
                fontSize: '1rem',
                backgroundColor: '#ffffff',
                color: '#000000',
                border: 'none',
                cursor: 'pointer',
                borderRadius: '6px',
                fontWeight: '500',
              }}
            >
              Try again
            </button>
            <a
              href="/"
              style={{
                padding: '0.875rem 2rem',
                fontSize: '1rem',
                color: '#ffffff',
                textDecoration: 'none',
                border: '2px solid rgba(255, 255, 255, 0.3)',
                borderRadius: '6px',
                fontWeight: '500',
                display: 'inline-block',
              }}
            >
              Homepage
            </a>
          </div>
        </div>
      </body>
    </html>
  )
}
